
// src/i18n/es/simulators.ts
const simulators = {
  name: 'Simuladores',
  
  controls: {
    register: 'Registrar Dispositivo',
    start: 'Iniciar Simulación',
    stop: 'Detener Simulación',
    running: 'Ejecutando...',
    clear: 'Limpiar Datos',
    heartbeat_send: 'Enviar Heartbeat',
    heartbeat_start: 'Iniciar Heartbeat Automático',
    heartbeat_stop: 'Detener Heartbeat Automático',
    registered_success: 'Dispositivo registrado correctamente',
    heartbeat_active: 'Heartbeat automático activo',
    heartbeat_every: 'cada 30s',
  },
  
  config: {
    title: 'Configuración',
    api_url: 'URL de API',
    hotel: 'Instalación',
    hotel_select: 'Seleccione una instalación',
    device_id: 'ID de Dispositivo',
    device_id_helper: 'Identificador único para este dispositivo',
    session_count: 'Número de Sesiones',
    error_rate: 'Tasa de Error (%)',
    error_rate_helper: 'Porcentaje de sesiones con errores',
    abandonment_rate: 'Tasa de Abandono (%)',
    abandonment_rate_helper: 'Porcentaje de sesiones abandonadas',
    delay_steps: 'Demora Entre Pasos (ms)',
    delay_sessions: 'Demora Entre Sesiones (ms)',
    select_hotel_first: 'Por favor, seleccione una instalación primero',
    error_loading_devices: 'Error cargando dispositivos',
    use_custom_device: 'Usar ID de dispositivo personalizado (entrada manual)',
    device_id_help: 'Introduzca el código de instalación (ej., KR250101.1)',
    select_device: 'Seleccionar Dispositivo',
    select_device_placeholder: 'Elegir un dispositivo...',
    loading_devices: 'Cargando dispositivos...',
    no_devices: 'No hay dispositivos disponibles',
    no_devices_in_hotel: 'Esta instalación no tiene dispositivos registrados. Active "Usar ID de dispositivo personalizado" para introducir uno manualmente, o registre un dispositivo primero.',
  },
  
  stats: {
    title: 'Estadísticas',
    total: 'Total de Sesiones',
    successful: 'Exitosas',
    failed: 'Fallidas',
    abandoned: 'Abandonadas',
    average_time: 'Tiempo Promedio',
    events: 'Total de Eventos',
  },
  
  log: {
    title: 'Registro de Eventos',
    no_logs: 'Aún no hay eventos',
    search_placeholder: 'Buscar en registros...',
    filter: {
      all: 'Todos',
      info: 'Info',
      success: 'Éxito',
      warning: 'Advertencia',
      error: 'Error',
    },
  },
  
  index: {
    title: 'Simuladores',
    subtitle: 'Seleccione un simulador para probar el envío de eventos al sistema',
    kiosk: {
      title: 'Kiosk',
      description: 'Simula el proceso completo de check-in en un kiosko físico con dispensador de llaves',
    },
    dispenser: {
      title: 'Dispensador',
      description: 'Simula únicamente el dispensador de llaves físicas',
    },
    mobile_desk: {
      title: 'Mobile Desk',
      description: 'Simula check-in desde dispositivo móvil del staff en recepción',
    },
    mobile_kiosk: {
      title: 'Mobile Kiosk',
      description: 'Simula check-in desde terminal móvil o física',
    },
    online_checkin: {
      title: 'Online Check-in',
      description: 'Simula pre check-in online desde web de la instalación',
    },
    open_button: 'Abrir',
    coming_soon: 'Próximamente',
  },
  
  kiosk: {
    title: 'Simulador de Kiosko',
    description: 'Simula el proceso completo de check-in en un kiosko físico',
    enhanced_description: 'Simulador avanzado de kiosko con correlación de journey y analíticas mejoradas',
    journey_type: {
      label: 'Tipo de Journey',
      new_checkin: 'Nuevo Check-in',
      continue_precheckin: 'Continuar Pre Check-in',
      walking_guest: 'Huésped Walk-in',
      hybrid_abandonment: 'Abandono Híbrido',
    },
    guest_config: {
      label: 'Configuración de Huésped',
      multiple_reservations: 'Tiene Múltiples Reservas',
      room_preassigned: 'Habitación Pre-asignada',
    },
    guest_type: {
      label: 'Tipo de Huésped',
      reservation: 'Con Reserva',
      walking: 'Walk-in',
    },
    checkin_type: {
      label: 'Tipo de Check-in',
      reservation: 'Con Reserva',
      walking: 'Walk-in',
    },
    key_delivery: {
      label: 'Método de Entrega de Llave',
      physical: 'Llave Física (Dispensador)',
      digital: 'Llave Digital (Móvil)',
      qr_dispenser: 'QR para Dispensador',
      manual: 'Entrega Manual (Staff)',
      magnetic_card: 'Tarjeta Magnética',
      rfid_card: 'Tarjeta RFID',
      conventional_key: 'Llave Convencional',
      digital_pin: 'PIN Digital',
      digital_mobile: 'Digital Móvil',
    },
    sections: {
      to_process: 'Secciones a Procesar',
      search: 'Buscar Reserva',
      room_selection: 'Selección de Habitación',
      identification: 'Identificación de Huésped',
      signature: 'Firma Digital',
      upselling: 'Ventas Adicionales',
      payment: 'Pago',
    },
    stats: {
      reservations: 'Con Reserva',
      walking: 'Walk-in',
      continued_precheckin: 'Pre Check-in Continuado',
      keys_dispensed: 'Llaves Dispensadas',
      key_errors: 'Errores de Dispensador',
      correlatable: 'Journeys Correlacionables',
    },
  },

  dispenser: {
    title: 'Simulador de Dispensador',
    description: 'Simula únicamente el dispensador de llaves físicas',
    qr_type: {
      label: 'Tipo de Código QR',
      reservation: 'Número de Reserva',
      room: 'Número de Habitación',
    },
    checkin_source: {
      label: 'Origen del Check-in',
      precheckin: 'Pre Check-in',
      kiosk: 'Kiosko',
      dispenser: 'Solo Dispensador',
    },
    dispenser_unit: 'Unidad de Dispensador',
    perform_pms_checkin: 'Realizar check-in en el sistema de reservas',
    stats: {
      mech_jam: 'Atascos Mecánicos',
      out_of_keys: 'Sin Llaves',
      sensor_error: 'Errores de Sensor',
      from_precheckin: 'Desde Pre Check-in',
      from_kiosk: 'Desde Kiosko',
    },
  },

  mobile_desk: {
    title: 'Simulador de Mobile Desk',
    description: 'Simula check-in desde dispositivo móvil del staff',
    receptionist_name: 'Nombre del Recepcionista',
    checkin_type: {
      label: 'Tipo de Check-in',
      reservation: 'Con Reserva',
      walking: 'Walk-in',
    },
    key_delivery: {
      label: 'Método de Entrega de Llave',
      digital: 'Llave Digital',
      qr: 'Código QR',
      physical: 'Llave Física',
      manual: 'Entrega Manual',
    },
    document_scan: {
      label: 'Método de Escaneo de Documento',
      auto: 'OCR Automático',
      manual: 'Entrada Manual',
      photo: 'Solo Foto',
    },
    stats: {
      reservations: 'Con Reserva',
      walking: 'Walk-in',
      payment_success: 'Pago Exitoso',
      keys_delivered: 'Llaves Entregadas',
      digital_keys: 'Llaves Digitales',
      qr_dispenser: 'Dispensador QR',
      manual_keys: 'Llaves Manuales',
      physical_keys: 'Llaves Físicas',
      ocr_scans: 'Escaneos OCR',
      manual_entry: 'Entrada Manual',
    },
  },

  mobile_kiosk: {
    title: 'Simulador de Mobile Kiosk',
    description: 'Simula auto check-in en terminal móvil o física',
    terminal_type: {
      label: 'Tipo de Terminal',
      mobile: 'Terminal Móvil',
      physical: 'Terminal Física',
    },
    checkin_type: {
      label: 'Tipo de Check-in',
      reservation: 'Con Reserva',
      walking: 'Walk-in',
    },
    mobile_key: {
      label: 'Método de Llave Móvil',
      code: 'Código de Acceso',
      app: 'App Móvil',
      qr: 'Código QR',
      manual: 'Entrega Manual',
    },
    physical_key: {
      label: 'Método de Llave Física',
      physical: 'Llave Física',
      digital: 'Llave Digital',
      manual: 'Entrega Manual',
    },
    info: {
      mobile: 'Terminal móvil para check-in asistido por personal con opciones flexibles de entrega de llaves',
      physical: 'Terminal de kiosko físico para check-in autoservicio similar al kiosko tradicional',
    },
    stats: {
      reservations: 'Con Reserva',
      walking: 'Walk-in',
      keys_delivered: 'Llaves Entregadas',
      mobile_keys: 'Llaves Móviles',
      physical_keys: 'Llaves Físicas',
      from_mobile: 'Terminal Móvil',
      from_physical: 'Terminal Física',
      digital_codes: 'Códigos Digitales',
      qr_dispenser: 'QR para Dispensador',
    },
  },

  online_checkin: {
    title: 'Simulador de Check-in Online',
    description: 'Simula pre check-in desde web de la instalación',
    key_delivery: {
      label: 'Método de Entrega de Llave',
    },
    digital_key_method: {
      label: 'Método de Llave Digital',
      mobile: 'App Móvil',
      sms: 'SMS',
      email: 'Email',
      none: 'Ninguno',
    },
    link_access: {
      label: 'Método de Acceso al Link',
      email: 'Link por Email',
      sms: 'Link por SMS',
      direct: 'Acceso Directo',
    },
    digital_key_rate: 'Tasa de Llave Digital (%)',
    stats: {
      digital_keys: 'Llaves Digitales Enviadas',
      payment_success: 'Pagos Exitosos',
      payment_error: 'Errores de Pago',
      from_email: 'Desde Email',
      from_sms: 'Desde SMS',
      from_direct: 'Acceso Directo',
    },
  },

  journey: {
    title: 'Visualización de Journey',
    no_journey: 'No hay journey activo',
    phase_precheckin: 'Pre-Check-In',
    phase_checkin: 'Check-In',
    phase_key: 'Entrega de Llave',
    journey_id: 'ID de Journey',
    guest_type: 'Tipo de Huésped',
    reservation: 'Reserva',
    room: 'Habitación',
    correlation_status: 'Estado de Correlación',
    correlatable: 'Correlacionable',
    not_correlatable: 'No Correlacionable',
    correlation_window: 'Ventana de Correlación',
    correlation_method: 'Método de Correlación',
    section_s: 'Buscar Reserva',
    section_r: 'Selección de Habitación',
    section_i: 'Identificación de Huésped',
    section_f: 'Firma Digital',
    section_u: 'Ventas Adicionales',
    section_p: 'Pago',
    section_k: 'Entrega de Llave',
    status_not_started: 'No Iniciado',
    status_in_progress: 'En Progreso',
    status_completed: 'Completado',
    status_failed: 'Fallido',
    status_abandoned: 'Abandonado',
  },
  
  wizard: {
    step_device: 'Seleccionar Dispositivo',
    step_config: 'Configurar',
    step_run: 'Ejecutar Test',
    select_hotel: 'Seleccionar Instalación',
    select_hotel_desc: 'Elige la instalación donde está instalado el dispositivo',
    select_device: 'Seleccionar Dispositivo',
    select_device_desc: 'Elige el dispositivo que se usará para este test',
    ready_title: 'Listo para Ejecutar',
    ready_desc: 'Todo está configurado. Pulsa el botón de abajo para iniciar el test.',
    ready_summary: 'El dispositivo se conectará automáticamente y el test comenzará.',
    cancel: 'Cancelar',
    new_test: 'Nuevo Test',
    activity_log: 'Registro de Actividad',
    result_success: 'Test completado correctamente',
    result_failed: 'Test completado con errores',
    result_duration: 'Duración: %{duration}s',
    result_events: '%{count} evento enviado |||| %{count} eventos enviados',
    phase_connecting: 'Conectando dispositivo',
    phase_running: 'Ejecutando test',
    phase_completing: 'Completando',
    run_test: 'Ejecutar Test',
    running_test: 'Ejecutando test...',
    api_log_title: 'Peticiones API',
    api_log_count: '%{count} petición capturada |||| %{count} peticiones capturadas',
    api_log_export: 'Exportar',
    api_log_live: 'Las peticiones aparecen en tiempo real',
  },

  shared: {
    reservation_number: {
      label: 'Número de Reserva',
      auto_generate: 'Generar Automáticamente',
      manual: 'Manual (mismo número para journey combinado)',
      placeholder: 'Ej: RES001, BKNG12345',
      tooltip: 'Usa el mismo número en diferentes simuladores para crear journeys combinados (ej: pre-check-in + dispensar llave)',
      generate_new: 'Generar nuevo número',
    },
  },
};

export default simulators;